import {ref, computed} from "vue"
import {defineStore, acceptHMRUpdate} from "pinia"
import {firestore} from "@/firebase/index.js"
import {collection} from "firebase/firestore"
import {useSiteStore} from "./site"

export const useSiteBlocksCustomTemplatesStore = defineStore("siteBlocksCustomTemplates", () => {
  // stores
  const siteStore = useSiteStore()

  // state
  const templates = ref([])
  const status = ref("init")
  const unsubscribe = ref(null)

  // getters
  const siteBlocksCustomTemplatesLoaded = computed(() => status.value == "loaded")

  // actions
  async function bind() {
    const siteId = siteStore.siteId
    const collectionRef = collection(firestore, `sites/${siteId}/blocksCustomTemplates`)
    return await this.attach("templates", collectionRef)
  }

  async function unbind() {
    return await this.detach()
  }

  return {
    // state
    templates,
    status,
    unsubscribe,

    // getters
    siteBlocksCustomTemplatesLoaded,

    // actions
    bind,
    unbind,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSiteBlocksCustomTemplatesStore, import.meta.hot))
}
